<template>
  <div class="biography">
    <PageTitle :title="content.biography" :parentTitle="content.about" />
    <div class="hidden layout-padding grid-cols-6 gap-x-16 xl:grid">
      <div
        v-for="image in about?.gallery.slice(0, 3)"
        :key="image.id"
        class="biography-slide-img h-[550px] lg:h-[80vh] col-span-2"
        :style="`background:url(${image?.image})`"
      ></div>
    </div>
    <div class="h-max relative block xl:hidden">
      <swiper
        :slides-per-view="4"
        :space-between="80"
        :breakpoints="breakpoints"
        :navigation="navigation"
        :centeredSlides="true"
        :loop="true"
      >
        <swiper-slide v-for="image in about?.gallery.slice(0, 3)" :key="image.id">
          <div
            class="biography-slide-img h-[550px]"
            :style="`background:url(${image?.image})`"
          ></div>
        </swiper-slide>
      </swiper>
      <div
        class="absolute z-[2] md:hidden lg:rtl:left-[-56px] lg:ltr:right-[-56px] bottom-0 lg:h-20 h-12 flex justify-between items-center text-3xl bg-primary w-max transition-all duration-700 cursor-pointer lg:min-w-[216px] min-w-[120px]"
      >
        <div @click="nextSlide" class="lg:px-8 px-4 lg:py-6 py-2 prev-gallery-img group">
          <img
            src="/static/images/icons/arrow-left.svg"
            alt="arrow-left "
            class="lg:w-8 w-auto h-6 md:ltr:ml-2 md:rtl:mr-2 rtl:rotate-180 md:group-hover:ml-0 transition-all duration-300"
          />
        </div>
        <div @click="prevSlide" class="lg:px-8 px-4 lg:py-6 py-2 next-gallery-img group">
          <img
            src="/static/images/icons/arrow-right.svg"
            class="lg:w-8 w-auto h-6 md:ltr:mr-2 md:rtl:ml-2 rtl:rotate-180 md:group-hover:mr-0 transition-all duration-300"
            alt="arrow-left "
          />
        </div>
      </div>
    </div>

    <div
      class="overflow-hidden transition-all relative duration-300 sm:mb-[15vh] mb-[7vh]"
      :class="showMore ? 'h-max' : 'h-[500px]'"
    >
      <div class="two-columns-container h-max" id="biography-text">
        <div
          class="sm:pt-[15vh] pt-[7vh] layout-padding two-columns overflow-hidden"
          v-html="about?.data?.description"
        ></div>
      </div>
      <div :class="!showMore ? 'absolute' : 'relative'"
        class=" bottom-0 left-0 bg-gradient-to-t from-white to-transparent mt-5 font-extrabold w-full text-center h-36 flex items-center justify-center cursor-pointer"
        @click="showMoreText"
      >
        <div
          class="py-4 px-10 bg-primary w-max bottom-0 transition-all duration-700 hover:bg-secondary cursor-pointer min-w-[216px] ltr:left-0 rtl:right-0"
        >
          {{ !showMore? content.showMore : content.showLess }}
        </div>
      </div>
    </div>
    <div
      class="w-full lg:h-[20vh] h-[15vh] separator-img-about"
      style="background: url(/static/images/about-separator-3.jpg)"
    ></div>

    <div class="mt-20 h-max layout-padding grid grid-cols-2 gap-x-20">
      <div class="lg:col-span-1 col-span-2">
        <div
          class="w-full lg:h-[90vh] h-[75vh] experience-slider-img flex items-end relative"
        >
          <div
            v-for="(slide, index) in about?.articles[0]?.gallery"
            :key="index"
            :class="currentSlide == index ? 'slide-show' : 'slide-hide'"
            class="w-full absolute lg:h-[90vh] h-[75vh]"
            :style="`background: url(${slide?.image})`"
          ></div>
          <div class="h-20 flex w-full justify-between items-center relative">
            <div
              class="absolute lg:rtl:left-[-56px] lg:ltr:right-[-56px] lg:bottom-[50px] bottom-0 lg:h-20 h-12 flex justify-between items-center text-3xl bg-primary w-max transition-all duration-700 cursor-pointer lg:min-w-[216px] min-w-[120px]"
            >
              <div
                @click="nextSlide"
                class="lg:px-8 px-4 lg:py-6 py-2 prev-painting-details group"
              >
                <img
                  src="/static/images/icons/arrow-left.svg"
                  alt="arrow-left "
                  class="lg:w-8 w-auto h-6 md:ltr:ml-2 md:rtl:mr-2 rtl:rotate-180 md:group-hover:ml-0 transition-all duration-300"
                />
              </div>
              <div
                @click="prevSlide"
                class="lg:px-8 px-4 lg:py-6 py-2 next-painting-details group"
              >
                <img
                  src="/static/images/icons/arrow-right.svg"
                  class="lg:w-8 w-auto h-6 md:ltr:mr-2 md:rtl:ml-2 rtl:rotate-180 md:group-hover:mr-0 transition-all duration-300"
                  alt="arrow-left "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="lg:col-span-1 col-span-2 pt-20 lg:pt-0 grid place-content-center experience-text"
      >
        <div class="text-3xl">{{ about?.articles[0]?.title }}</div>
        <div
          class="mt-8 lg:w-10/12 w-full leading-7"
          v-html="about?.articles[0]?.description"
        ></div>
      </div>
    </div>
    <div class="lg:my-20 my-0 layout-padding grid grid-cols-2 gap-x-20">
      <div
        class="lg:col-span-1 col-span-2 grid place-content-center article-text lg:order-first order-last py-10 lg:pt-0"
      >
        <div class="text-3xl">{{ about?.articles[1]?.title }}</div>
        <div
          class="mt-12 lg:w-10/12 w-full leading-7"
          v-html="about?.articles[1]?.description"
        ></div>
      </div>
      <div class="lg:col-span-1 col-span-2 lg:order-last order-first">
        <div
          class="w-full lg:h-[90vh] h-[50vh] article-img relative"
          :style="`background: url(${about?.articles[1]?.image})`"
        >
          <router-link to="/personalphotos"
            ><div
              class="py-4 px-10 bg-primary w-max absolute lg:bottom-8 bottom-0 transition-all duration-700 hover:bg-secondary cursor-pointer min-w-[216px] ltr:left-0 rtl:right-0 lg:ltr:left-[-108px] lg:rtl:right-[-108px]"
            >
              {{ content.viewPhotoGallery }}
            </div></router-link
          >
        </div>
      </div>
    </div>
    <!-- <div class="w-full h-[25vh] mt-[15vh] bg-primary grid grid-cols-2">
      <div class="col-span-1 relative border-t border-r border-[#70707040]">
        <router-link to="/personalphotos">
          <div class="text-center h-full grid place-content-center">

            <div class="font-bold text-3xl  cursor-pointer">
              Personal Photos
            </div>
          </div></router-link
        >
      </div>
      <div class="col-span-1 relative border-t border-[#70707040]">
        <router-link to="/archive/videos">
          <div class="text-center h-full grid place-content-center">

            <div class="font-bold text-3xl  cursor-pointer">
              Videos
            </div>
          </div></router-link
        >
      </div>
    </div> -->
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/swiper.min.css";
export default {
  data() {
    return {
      currentSlide: 0,
      showMore: false,
      biographyArray: [],
      biography: "",
      breakpoints: {
        // when window width is >= 320px
        20: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        // when window width is >= 480px
        800: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        // when window width is >= 640px
        1300: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
      navigation: {
        nextEl: ".next-gallery-img",
        prevEl: ".prev-gallery-img",
      },
    };
  },
  inject: ["content"],
  computed: {
    about() {
      return this.$store.getters["about/about"];
    },
  },

  methods: {
    showMoreText() {
      this.showMore = !this.showMore;
     setTimeout(() => {
      ScrollTrigger.refresh();
     }, 1000);
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide = this.currentSlide - 1;
      } else if (this.currentSlide == 0) {
        this.currentSlide = this.about?.articles[0]?.gallery?.length - 1;
      }
    },
    nextSlide() {
      if (this.currentSlide < this.about?.articles[0]?.gallery?.length - 1) {
        this.currentSlide = this.currentSlide + 1;
      } else if (this.currentSlide == this.about?.articles[0]?.gallery?.length - 1) {
        this.currentSlide = 0;
      }
    },
    parallex() {
      // gsap.to(".two-columns-container", {
      //   y: "-10%",
      //   scrollTrigger: {
      //     id: "parallex",
      //     trigger: ".two-columns-container",
      //     start: "top top",
      //     end: "bottom 100",
      //     scrub: 1,
      //   },
      // });
      gsap.to(".separator-img-about", {
        y: "-20%",
        scrollTrigger: {
          id: "parallex",

          trigger: ".two-columns",
          start: "btttom btttom",

          scrub: 1,
        },
      });

      gsap.to(".experience-text", {
        y: "-20%",
        scrollTrigger: {
          id: "parallex",

          trigger: ".experience-text",
          start: "top 300",
          end: "bottom 300",
          scrub: 1,
        },
      });
      gsap.to(".experience-slider-img", {
        y: "-20%",
        scrollTrigger: {
          id: "parallex",

          trigger: ".experience-slider-img",
          start: "top 100",
          end: "bottom 200",
          scrub: 1,
        },
      });
      gsap.to(".article-text", {
        y: "-10%",
        scrollTrigger: {
          id: "parallex",

          trigger: ".article-text",
          start: "top 100",
          end: "bottom 200",
          scrub: 1,
        },
      });
      gsap.to(".article-img", {
        y: "-15%",
        scrollTrigger: {
          id: "parallex",

          trigger: ".article-img",
          start: "top 100",
          end: "bottom 200",
          scrub: 1,
        },
      });
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.parallex();
    setTimeout(() => {
      let biographyTextHeight = document.getElementById("biography-text").clientHeight;
      if (biographyTextHeight < window.innerHeight) {
        this.showMore = true;
      }
    }, 200);
  },
};
</script>